import { CheckboxFilter } from '@lifebit-ai/lds'
import React from 'react'

import { ApprovedIcon, IconContainer, PendingIcon, RejectedIcon } from 'modules/requests/filters/StatusFilter.styles'
import type { Option } from 'modules/types'
import { DataAccessRequestStatus } from 'services/data-access-requests/enums'

interface DataAccessRequestStatusFilterProps {
  onApply: (filteredOptions: Option[]) => void
  onReset: () => void
}

export const DataAccessRequestStatusFilter = ({ onApply, onReset }: DataAccessRequestStatusFilterProps) => {
  const options = [
    {
      label: 'Pending',
      value: DataAccessRequestStatus.PendingVerification,
      element: (
        <IconContainer>
          <PendingIcon />
          <span>Pending</span>
        </IconContainer>
      )
    },
    {
      label: 'Approved',
      value: DataAccessRequestStatus.Approved,
      element: (
        <IconContainer>
          <ApprovedIcon />
          <span>Approved</span>
        </IconContainer>
      )
    },
    {
      label: 'Rejected',
      value: DataAccessRequestStatus.Rejected,
      element: (
        <IconContainer>
          <RejectedIcon />
          <span>Rejected</span>
        </IconContainer>
      )
    }
  ]

  return <CheckboxFilter label="Status" options={options} onApply={onApply} onReset={onReset} withFuzzySearch={false} />
}
